<template>
    <b-container fluid="">
        <button type="button" id="btn_flotante_configuracion" class="btn btn-sm btn-outline-dark"
            v-if="permisos['inventarios.movimientos.salidas.motivos']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
            @click="abrir_modal_crear_motivo">
            <i class="fas fa-cog"></i>
        </button>
        <button type="button" id="btn_flotante_configuracion" class="btn btn-sm btn-outline-dark" v-else disabled>
            <i class="fas fa-cog"></i>
        </button>
        <b-row>
            <div class="col-sm-12 mt-2">
                <h3>
                    Salidas
                </h3>
            </div>
            <div class="col-sm-6 mt-1">
                <label for="" class="form-label">Documento</label>
                <input type="text" readonly class="form-control form-control-sm" v-model="correlativos.SALIDAS.extra">
            </div>
            <div class="col-sm-6 mt-1">
                <label for="" class="form-label">Motivo salida</label>
                <select class="form-control form-control-sm" v-model="motivo_salida">
                    <option value="">Seleccionar</option>
                    <option v-for="(item, index) in motivos_salida" :key="index" :value="item.id">{{ item.motivo }}
                    </option>
                </select>
            </div>
            <!-- <div class="col-sm-2 mt-4">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="generar_reporte">test</button>
            </div> -->
            <div class="col-sm-8 mt-3">
                <label for="" class="form-label">Código</label>
                <input type="text" id="campo_codigo_salida_producto" list="listado_productos__" autocomplete="off"
                    class="form-control form-control-sm" v-model="codigo_producto"
                    @keydown.tab="consulta_de_producto_por_codigo" @keyup.enter="consulta_de_producto_por_codigo">
                <datalist id="listado_productos__">
                    <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index" :value="item.codigo">{{
                        item.nombre }}
                    </option>
                </datalist>
            </div>

            <!-- <div class="col-sm-2 mt-3">
                <label for="" class="form-label">Precio</label>
                <input type="number" step="0.01" class="form-control form-control-sm" v-model="precio_unitario">
            </div> -->
            <div class="col-sm-2 mt-3">
                <label for="" class="form-label">Cantidad</label>
                <input type="number" min="1" class="form-control form-control-sm" v-model="cantidad">
            </div>
            <div class="col-sm-2 mt-5">
                <button v-if="codigo_producto != ''" type="button" @click="agregar_elemento_al_listado"
                    class="btn btn-sm btn-dark btn-block"><i class="fas fa-plus"></i></button>
                <button v-else type="button" disabled class="btn btn-sm btn-dark btn-block"><i
                        class="fas fa-plus"></i></button>
            </div>

            <div class="col-sm-12 mt-3">
                <div class="contenedor_texto_articulo">
                    {{ nombre_producto }}
                </div>
            </div>

            <div class="col-sm-12 mt-3">
                <div class="marco_lista_compras">

                    <table class="table table-sm table-striped table-bordered" style="font-size: 11px;">
                        <thead>
                            <tr>
                                <th style="width: 15%;text-align: center;">
                                    Código
                                </th>
                                <th style="width: 40%;">
                                    Nombre
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    P.Unitario
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    Cantidad
                                </th>
                                <th style="width: 15%;text-align: center;">
                                    Sub total
                                </th>
                                <th style="width: 10%;text-align: center;">
                                    ...
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in listado" :key="index">
                                <td style="text-align: center;">
                                    {{ item.codigo }}
                                </td>
                                <td>
                                    {{ item.nombre }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.precio_unitario }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.cantidad }}
                                </td>
                                <td style="text-align: center;">
                                    {{ item.sub_total }}
                                </td>
                                <td style="text-align: center;">
                                    <b-button type="button" size="sm" style="font-size: 10px;" variant="outline-danger"
                                        @click="eliminar_elemento_del_listado(index)"><i
                                            class="fas fa-trash"></i></b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-sm-8 mt-3">
                <div class="contenedor_texto_articulo">
                    TOTAL: {{ gran_total.toLocaleString(undefined, {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                    }) }}
                </div>
            </div>

            <div class="col-sm-4 mt-3">
                <button v-if="permisos['inventarios.movimientos.salidas']?.crear || ES_ROOT" type="button"
                    class="btn btn-sm btn-outline-dark btn-block" @click="guardar_salidas">Guardar</button>
                <button v-else type="button" class="btn btn-sm btn-outline-dark btn-block" disabled>Guardar</button>
            </div>
        </b-row>

        <Muestra v-if="modal_crear_motivo" v-on:salir="cerrar_modal_crear_motivo" />
    </b-container>
</template>

<script>
    import { minix } from '@/components/functions/alertas'
    import { mapActions, mapGetters, mapState } from 'vuex'
    import Muestra from './Motivos/Muestra.vue'
    import pdfMake from 'pdfmake/build/pdfmake'
    import pdfFonts from "pdfmake/build/vfs_fonts";
    pdfMake.addVirtualFileSystem(pdfFonts);

    export default {
        name: 'Salida',
        computed: {
            ...mapState(['correlativos', 'motivos_salida', 'permisos', 'datos_usuario']),
            ...mapGetters(['ES_ROOT', 'FILTRAR_PRODUCTOS_POR_SUCURSAL'])
        },
        components: {
            Muestra
        },
        data() {
            return {
                modal_crear_motivo: false,
                listado: [],
                gran_total: 0,
                codigo_producto: '',
                nombre_producto: '-',
                precio_unitario: '',
                cantidad: 1,
                no_documento: '',
                motivo_salida: '',
                no_envio: 1234
            }
        },
        methods: {
            abrir_modal_crear_motivo() {
                this.modal_crear_motivo = true
            },
            cerrar_modal_crear_motivo() {
                this.modal_crear_motivo = false
            },
            async consulta_de_producto_por_codigo() {

                if (this.codigo_producto == '') {

                    console.log('No hay codigo de producto')

                } else {
                    let f = {
                        api: `articulos?filters[codigo][$eq][0]=${this.codigo_producto.trim()}&filters[sucursal][$eq][1]=0&filters[formula][$eq][2]=false`,
                        notificacion: { mensaje: 'Producto no encontrado' }
                    }

                    let r = await this.obtener_data(f)

                    if (r.length != 0) {

                        this.existe = true
                        this.codigo_producto = r[0].codigo
                        this.nombre_producto = r[0].nombre
                        this.precio_unitario = r[0].precio_costo

                    } else {
                        this.existe = false

                    }


                }


            },
            eliminar_elemento_del_listado(index) {
                this.listado.splice(index, 1)
                let contador = 0

                for (let i = 0; i < this.listado.length; i++) {
                    const e = this.listado[i];

                    contador += e.sub_total

                }

                this.gran_total = contador
            },
            agregar_elemento_al_listado() {
                if (this.codigo_producto == '' || this.nombre_producto == '' || this.precio_unitario == '' || this.cantidad == '') {

                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })

                } else {

                    if (this.cantidad <= 0 || this.precio_unitario <= 0) {
                        minix({ icon: 'error', mensaje: 'Los valores no pueden ser negativos o cero', tiempo: 3000 })

                    } else {

                        if (this.existe) {
                            let f = {
                                codigo: this.codigo_producto.trim(),
                                nombre: this.nombre_producto,
                                precio_unitario: this.precio_unitario,
                                cantidad: this.cantidad,
                                sub_total: this.precio_unitario * this.cantidad
                            }

                            this.listado.push(f)

                            let contador = 0

                            for (let i = 0; i < this.listado.length; i++) {
                                const e = this.listado[i];

                                contador += e.sub_total

                            }

                            this.gran_total = contador

                            this.codigo_producto = ''
                            this.nombre_producto = '-'
                            this.precio_unitario = ''
                            this.cantidad = 1

                            document.getElementById('campo_codigo_salida_producto').focus()

                        } else {
                            minix({ icon: 'error', mensaje: 'El producto no existe', tiempo: 3000 })
                            document.getElementById('campo_codigo_salida_producto').focus()
                        }


                    }

                }
            },
            async generar_reporte() {

                const filas = this.listado.map((item) => [item.codigo, item.nombre, `Q${item.precio_unitario.toLocaleString(undefined, {
                    minimumFractionDigits: 2, maximumFractionDigits: 2
                })}`, item.cantidad, item.sub_total.toLocaleString(undefined, {
                    minimumFractionDigits: 2, maximumFractionDigits: 2
                })])

                const documentDefinition = {
                    content: [
                        {
                            text: `Envío #${this.no_envio}`,
                            style: [
                                'cabecera'
                            ]
                        },
                        {
                            style: 'tableExample',
                            table: {
                                headerRows: 1,
                                widths: ['*', '*', '*', '*', '*'],
                                body: [
                                    // ['Código', 'Nombre', 'Precio', 'Cantidad', 'Subtotal'],
                                    [{ text: 'Código', style: 'tablaCabecera' }, { text: 'Nombre', style: 'tablaCabecera' }, { text: 'Precio', style: 'tablaCabecera' }, { text: 'Cantidad', style: 'tablaCabecera' }, { text: 'Subtotal', style: 'tablaCabecera' }],
                                    ...filas,
                                    ['', '', '', 'Total', {
                                        text: `Q${this.gran_total.toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        })}`, style: {
                                            alignment: 'center'
                                        }
                                    }]
                                ]
                            },
                            layout: {
                                fillColor: function (rowIndex, node, columnIndex) {
                                    return (rowIndex % 2 === 0) ? '#e5dfdf' : null;
                                }
                            }
                        }
                    ],
                    styles: {
                        cabecera: {
                            fontSize: 20,
                            bold: true,
                            alignment: 'left'
                        },
                        tableExample: {
                            margin: [0, 5, 0, 15]
                        },
                        tablaCabecera: {
                            bold: true,
                            fontSize: 13,
                            color: 'black'
                        }
                    }
                }

                pdfMake.createPdf(documentDefinition).open()
            },
            async guardar_salidas() {
                if (this.motivo_salida == '' || this.listado.length == 0) {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {

                    let f = {
                        api: `movimientos-cabeceras/g/salidas`,
                        formulario: {
                            dte: this.no_documento,
                            total_movimiento: this.gran_total,
                            listado: this.listado
                        }
                    }

                    await this.guardar_data(f)
                    this.gran_total = 0
                    this.listado = []
                }
            },
            ...mapActions(['obtener_data', 'guardar_data', 'obtener_correlativos', 'obtener_motivos_salidas'])
        },
        mounted() {
            this.obtener_correlativos()
            this.obtener_motivos_salidas()
        },
    }
</script>

<style>
    #btn_flotante_configuracion {
        position: fixed;
        top: 100px;
        right: 20px;
        z-index: 999;
    }
</style>
